import 'moment/locale/th';
import React, { useState, useEffect } from 'react';
import { formatComma, tableWidth, getTheme } from 'helpers/helpers';
import callApi from 'helpers/callapi';
import moment from 'moment';
import cn from 'classnames';
import _, { get, find, orderBy, uniqBy, filter } from 'lodash';
import { Link } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';

// Components
import CONSTANTS from 'constants/constants';
import {
  Button,
  Table,
  Pagination,
  Modal,
  Row,
  Col,
  Select,
  message,
  Input,
  Upload,
  Popconfirm,
  Spin,
  Tooltip,
} from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { arrayMoveImmutable } from 'array-move';
import { useHistory } from 'react-router-dom';

import styled from 'styled-components';
import { filterLabelAndValue } from 'helpers/helpers';

// constants
import ROUNDS from 'constants/rounds';
import TCAS_STATUSES from 'constants/tcas_statuses';

// import AdminDetailModal from './AdminModal';

const ORDER_STATUS = CONSTANTS.orderStatus;
const ORDER_LABEL = CONSTANTS.orderLabels;
const BANK = CONSTANTS.banks;

const Option = Select.Option;

moment.locale('th');

export default () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const me = useSelector((state) => state.user);

  const [loading, setLoading] = useState(false);
  const adminConfig = useSelector((state) => state.configs || {});
  // ลบสนามสอบได้เฉพาะตอน config center_site_deletable เปิด (API เช็คซ้ำอีกชั้น)
  const deletable = adminConfig.center_site_deletable === true;

  const [currentRound, setCurrentRound] = useState(adminConfig.current_round);
  const [sites, setSites] = useState([]);
  const [mode, setMode] = useState('display');
  const [isAddActive, setIsAddActive] = useState(false);

  const [tempSites, setTempSites] = useState([]);
  const [queryText, setQueryText] = useState('');
  const [searchSchoolList, setSearchSchoolList] = useState([]);
  const [schoolCount, setSchoolCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const onSearch = async (_page = 1) => {
    setLoading(true);
    const query = { page: _page || 1, q: queryText, limit: 20 };

    const { count, data: schools } = await callApi({
      url: '/schools',
      query,
    });
    setSearchSchoolList(schools);
    setSchoolCount(count);
    setLoading(false);
    window.scrollTo(0, 0);

    // const schools = await callApi({ url: '/exam-centers/me/sites' });
  };
  const onRemoveFilter = () => {
    setQueryText('');
    setSearchSchoolList([]);
    setSchoolCount(0);
    setCurrentPage(1);
  };
  const onChangePage = (page) => {
    setCurrentPage(page);
    onSearch(page);
  };

  const getSchools = async () => {
    setLoading(true);
    const _sites = await callApi({ url: '/exam-centers/me/sites' });
    setSites(_sites.data);
    setLoading(false);
    return _sites.data;
  };
  useEffect(() => {
    getSchools();
    if (me.role === 'super') {
      history.replace('/dashboard');
    }
  }, []);

  // {['1', '2', '4'].map((roundNumber) => {
  //   const round = find(ROUNDS, { value: `${roundNumber}_2565` });

  //   if (adminConfig.current_round !== roundNumber) {
  //     return <></>;
  //   }

  // }

  const onAddSite = async (i) => {
    const school = searchSchoolList[i];
    setLoading(true);
    try {
      const result = await callApi({
        url: `/exam-sites`,
        method: 'post',
        body: {
          site_school_code: school.code,
          school_name: school.name,
          province: school.province_name,
          amphur: school.amph_name,
        },
      });
      // สนามที่เคยลบไปจะถูกกู้คืนด้วยรหัสเดิม แต่ห้องสอบถูกลบถาวรไปแล้ว ต้องเพิ่มใหม่
      if (get(result, 'restored')) {
        Modal.success({
          title: 'กู้คืนสนามสอบเรียบร้อย',
          content: `สนามสอบนี้เคยถูกลบไว้ ระบบกู้คืนด้วยรหัสเดิม ${get(result, 'site_code')} แล้ว แต่ต้องเพิ่มห้องสอบใหม่ทั้งหมด`,
        });
      }
      await getSchools();
      setLoading(false);
      setMode('display');
    } catch (err) {
      Modal.error({
        title: 'เกิดข้อผิดพลาด',
        content: _.get(err, 'reason.message'),
      });
      setLoading(false);
    }
  };

  const onClickEditButton = () => {
    setMode('sortable');
    setTempSites([...sites]);
  };
  const onCancelEdit = () => {
    setMode('display');
    setSites(tempSites);
  };

  const onDelete = async (siteCode) => {
    setLoading(true);
    try {
      await callApi({ url: `/exam-sites/${siteCode}`, method: 'delete' });
      const schools = await getSchools();
      setTempSites([...schools]);
      message.success('ลบสนามสอบเรียบร้อย');
    } catch (err) {
      Modal.error({
        title: 'ไม่สามารถลบสนามสอบได้',
        content: _.get(err, 'reason.message') || 'เกิดข้อผิดพลาด',
      });
    }
    setLoading(false);
  };

  const onSaveSequece = async () => {
    setLoading(true);
    const ids = sites.map((site) => site._id);
    await callApi({ url: `/exam-centers/${me.center_code}/sites`, method: 'put', body: { sites: ids } });
    await getSchools();
    setLoading(false);
    setMode('display');
  };

  const renderTable = () => {
    // const stat = get(center, `info_by_days.day${INFO.dayIndex}`);

    return (
      <>
        <thead className="th-orange">
          <tr>
            <th>ลำดับ</th>
            <th>ชื่อสนามสอบ</th>
            <th>รหัส</th>
            <th>จังหวัด</th>
            <th>อำเภอ</th>
            <th className="text-right">ห้อง</th>
            <th className="text-right">ที่นั่งสอบ</th>
            <th className="text-center">
              <Tooltip title="ห้องสอบปกติ กระดาษ">
                <i className="i-paper"></i>
              </Tooltip>
            </th>
            <th className="text-center">
              <Tooltip title="ห้องสอบสำหรับผู้ต้องการความช่วยเหลือพิเศษ กระดาษ">
                <i className="i-disabled"></i>
              </Tooltip>
            </th>
            <th className="text-center">
              <Tooltip title="ห้องสอบปกติ คอมพิวเตอร์">
                <i className="i-computer"></i>
              </Tooltip>
            </th>

            <th></th>
          </tr>
        </thead>
        <tbody>
          {sites.map((site, index) => {
            const stat = get(site, `stats`);
            return (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{site.school_name}</td>
                <td>{site.site_school_code}</td>
                <td>{site.province}</td>
                <td>{site.amphur}</td>
                <td className="_nowrap text-right">
                  {get(stat, 'rooms') + (get(stat, 'special_rooms') || 0) + (get(stat, 'cbt_rooms') || 0)}
                </td>
                <td className="_nowrap text-right">
                  {get(stat, 'seats') + (get(stat, 'special_seats') || 0) + (get(stat, 'cbt_seats') || 0)}
                </td>

                <td className="_nowrap text-center">
                  {get(stat, 'rooms')} : {get(stat, 'seats')}
                </td>
                <td className="_nowrap text-center">
                  {get(stat, 'special_rooms')} : {get(stat, 'special_seats')}
                </td>
                <td className="_nowrap text-center">
                  {get(stat, 'cbt_rooms')} : {get(stat, 'cbt_seats')}
                </td>

                <td>
                  <Link to={`/site/${site.site_code}/room`} className="btn-manage">
                    จัดการห้องสอบ
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </>
    );
  };

  const renderSortableTable = () => {
    const DragHandle = SortableHandle(() => (
      <a>
        <i className="i-more"></i>
      </a>
    ));

    const SortableItem = SortableElement(({ value, sortIndex }) => {
      const site = value;
      const stat = get(site, `stats`);
      return (
        <tr key={sortIndex}>
          <td>
            <DragHandle />
          </td>
          <td>
            {site.exam_type === 'pbt' && deletable && (
              <Popconfirm
                title="หากทำการลบสนามสอบนี้จะเป็นการลบข้อมูลห้องสอบทั้งหมดในแต่ละวันด้วย"
                onConfirm={() => onDelete(site.site_code)}
                okText="ยืนยันการลบ"
                cancelText="ยกเลิก"
              >
                <a>
                  <i className="i-trash"></i>
                </a>
              </Popconfirm>
            )}
          </td>
          <td>{site.school_name}</td>
          <td>{site.site_school_code}</td>
          <td>{site.province}</td>
          <td>{site.amphur}</td>
          <td className="_nowrap text-right">
            {get(stat, 'rooms') + (get(stat, 'special_rooms') || 0) + (get(stat, 'cbt_rooms') || 0)}
          </td>
          <td className="_nowrap text-right">
            {get(stat, 'seats') + (get(stat, 'special_seats') || 0) + (get(stat, 'cbt_seats') || 0)}
          </td>

          <td className="_nowrap text-center">
            {get(stat, 'rooms')} : {get(stat, 'seats')}
          </td>
          <td className="_nowrap text-center">
            {get(stat, 'special_rooms')} : {get(stat, 'special_seats')}
          </td>
          <td className="_nowrap text-center">
            {get(stat, 'cbt_rooms')} : {get(stat, 'cbt_seats')}
          </td>
        </tr>
      );
    });
    const SortableList = SortableContainer(({ items }) => {
      return (
        <tbody>
          {items.map((value, index) => (
            <SortableItem key={`item-${index}`} index={index} sortIndex={index} value={value} />
          ))}
        </tbody>
      );
    });
    const onSortEnd = ({ oldIndex, newIndex }) => {
      setSites(arrayMoveImmutable(sites, oldIndex, newIndex));
    };

    return (
      <>
        <thead className="th-orange">
          <tr>
            <th></th>
            <th></th>
            {/* <th>ลำดับ</th> */}
            <th>ชื่อสนามสอบ</th>
            <th>รหัส</th>
            <th>จังหวัด</th>
            <th>อำเภอ</th>
            <th className="text-right">ห้อง</th>
            <th className="text-right">ที่นั่งสอบ</th>
            <th className="text-center">
              <Tooltip title="ห้องสอบปกติ กระดาษ">
                <i className="i-paper"></i>
              </Tooltip>
            </th>
            <th className="text-center">
              <Tooltip title="ห้องสอบสำหรับผู้ต้องการความช่วยเหลือพิเศษ กระดาษ">
                <i className="i-disabled"></i>
              </Tooltip>
            </th>
            <th className="text-center">
              <Tooltip title="ห้องสอบปกติ คอมพิวเตอร์">
                <i className="i-computer"></i>
              </Tooltip>
            </th>

            <th></th>
          </tr>
        </thead>
        <SortableList items={sites} onSortEnd={onSortEnd} helperClass="row-dragging" useDragHandle />
      </>
    );
  };

  return (
    <div>
      <Spin spinning={loading} delay={0}>
        <div className="t-main">
          <div className="flex gap-16">
            <h1>ข้อมูลสนามสอบ</h1>
            {me.exam_type.indexOf('pbt') > -1 && (
              <div className="action">
                <a
                  className={cn('btn-add-toggle', { active: isAddActive })}
                  onClick={() => setIsAddActive(!isAddActive)}
                >
                  เพิ่ม
                  <i className="i-down-button"></i>
                </a>
              </div>
            )}
          </div>
          {isAddActive && me.exam_type.indexOf('pbt') > -1 && (
            <div className="">
              <div className="t-card border-orange">
                <div className="filter">
                  <h3 className="title">เพิ่มข้อมูลสนามสอบจากฐานข้อมูล</h3>
                  <div className="flex">
                    <div className="col-25">
                      <div className="form-group">
                        <label>ชื่อสนามสอบ, รหัสสนามสอบ</label>
                        <input
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              onSearch();
                            }
                          }}
                          type="text"
                          className="form-control"
                          placeholder="ชื่อสนามสอบ, รหัสสนามสอบ"
                          value={queryText}
                          onChange={(e) => setQueryText(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="col-auto flex gap-16 items-center">
                      <a onClick={() => onSearch()} className="btn-main">
                        ค้นหาสนามสอบ
                      </a>{' '}
                      <a onClick={() => onRemoveFilter()} className="_h">
                        ล้างค่า
                      </a>
                    </div>
                  </div>
                </div>
                <div className="color-gray mt-1">
                  <small>หากไม่พบข้อมูลสนามสอบ กรุณาติดต่อผู้ดูแลระบบ</small>
                </div>

                {schoolCount > 0 && (
                  <>
                    <table className="t-table t-table-striped">
                      <thead className="th-orange">
                        <tr>
                          <th>ลำดับ</th>
                          <th>ชื่อสนามสอบ</th>
                          <th>รหัส</th>
                          <th>จังหวัด</th>
                          <th>อำเภอ</th>

                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {searchSchoolList.map((school, i) => {
                          return (
                            <tr>
                              <td>{i + 1}</td>
                              <td>{school.name}</td>
                              <td>{school.code}</td>
                              <td>{school.province_name}</td>
                              <td>{school.amph_name}</td>
                              <td>
                                <a onClick={() => onAddSite(i)}>เพิ่มสนามสอบ</a>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    <Pagination
                      current={currentPage}
                      onChange={onChangePage}
                      defaultPageSize={20}
                      total={schoolCount}
                      showSizeChanger={false}
                    />
                  </>
                )}
              </div>
            </div>
          )}

          <h3>
            <i className="i-con">
              <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18.75 8.50001H16.5V4.00001C16.5 3.75251 16.378 3.52101 16.1735 3.38101L11.4235 0.131006C11.168 -0.0439941 10.8315 -0.0439941 10.5765 0.131006L5.8265 3.38101C5.622 3.52101 5.5 3.75251 5.5 4.00001V8.50001H3.25C1.7335 8.50001 0.5 9.73401 0.5 11.25V20.25C0.5 20.664 0.8355 21 1.25 21H20.75C21.1645 21 21.5 20.664 21.5 20.25V11.25C21.5 9.73401 20.2665 8.50001 18.75 8.50001ZM5.25 17.5C5.25 17.776 5.026 18 4.75 18H4.25C3.974 18 3.75 17.776 3.75 17.5V15C3.75 14.724 3.974 14.5 4.25 14.5H4.75C5.026 14.5 5.25 14.724 5.25 15V17.5ZM5.25 12.5C5.25 12.776 5.026 13 4.75 13H4.25C3.974 13 3.75 12.776 3.75 12.5V12C3.75 11.724 3.974 11.5 4.25 11.5H4.75C5.026 11.5 5.25 11.724 5.25 12V12.5ZM8.5 17.5C8.5 17.776 8.276 18 8 18H7.5C7.224 18 7 17.776 7 17.5V15C7 14.724 7.224 14.5 7.5 14.5H8C8.276 14.5 8.5 14.724 8.5 15V17.5ZM8.5 12.5C8.5 12.776 8.276 13 8 13H7.5C7.224 13 7 12.776 7 12.5V12C7 11.724 7.224 11.5 7.5 11.5H8C8.276 11.5 8.5 11.724 8.5 12V12.5ZM11.75 17.5C11.75 17.776 11.526 18 11.25 18H10.75C10.474 18 10.25 17.776 10.25 17.5V15C10.25 14.724 10.474 14.5 10.75 14.5H11.25C11.526 14.5 11.75 14.724 11.75 15V17.5ZM11.75 12.5C11.75 12.776 11.526 13 11.25 13H10.75C10.474 13 10.25 12.776 10.25 12.5V12C10.25 11.724 10.474 11.5 10.75 11.5H11.25C11.526 11.5 11.75 11.724 11.75 12V12.5ZM11 9.00001C9.8955 9.00001 9 8.10451 9 7.00001C9 5.89551 9.8955 5.00001 11 5.00001C12.1045 5.00001 13 5.89551 13 7.00001C13 8.10451 12.1045 9.00001 11 9.00001ZM15 17.5C15 17.776 14.776 18 14.5 18H14C13.724 18 13.5 17.776 13.5 17.5V15C13.5 14.724 13.724 14.5 14 14.5H14.5C14.776 14.5 15 14.724 15 15V17.5ZM15 12.5C15 12.776 14.776 13 14.5 13H14C13.724 13 13.5 12.776 13.5 12.5V12C13.5 11.724 13.724 11.5 14 11.5H14.5C14.776 11.5 15 11.724 15 12V12.5ZM18.25 17.5C18.25 17.776 18.026 18 17.75 18H17.25C16.974 18 16.75 17.776 16.75 17.5V15C16.75 14.724 16.974 14.5 17.25 14.5H17.75C18.026 14.5 18.25 14.724 18.25 15V17.5ZM18.25 12.5C18.25 12.776 18.026 13 17.75 13H17.25C16.974 13 16.75 12.776 16.75 12.5V12C16.75 11.724 16.974 11.5 17.25 11.5H17.75C18.026 11.5 18.25 11.724 18.25 12V12.5Z"
                  fill="#FF8A00"
                />
              </svg>
            </i>{' '}
            มีสนามสอบ {sites.length} แห่ง
          </h3>
          <table className="t-table t-table-striped">
            {mode === 'display' && renderTable()}
            {mode === 'sortable' && renderSortableTable()}
          </table>
          <div className="_space"></div>

          {mode === 'display' && (
            <a className="btn-ghost pointer" onClick={() => onClickEditButton()}>
              แก้ไขลำดับหรือลบข้อมูล
            </a>
          )}
          {mode === 'sortable' && (
            <div className="flex items-center gap-16">
              <a className="btn-main btn-radius" onClick={() => onSaveSequece()}>
                บันทึกการแก้ไขอันดับ
              </a>
              <a className="_h" onClick={() => onCancelEdit()}>
                ยกเลิกการแก้ไข
              </a>
            </div>
          )}
        </div>
      </Spin>
    </div>
  );
};
